import { Component, OnInit, AfterViewInit, ViewChild, TemplateRef } from '@angular/core';
import { DataTableColumn } from '../../../shared/ui/data-table/data-table.component';
import { forkJoin } from 'rxjs';
import { ManagerService } from 'src/app/core';
import { PopupMessageService } from 'src/app/shared/message/services/message.service';

@Component({
  selector: 'app-manage-budget',
  templateUrl: './manage-budget.component.html',
  styleUrls: ['./manage-budget.component.scss']
})
export class ManageBudgetComponent implements OnInit, AfterViewInit {

  @ViewChild('quarterTpl') quarterTpl!: TemplateRef<any>;
  @ViewChild('americasTpl') americasTpl!: TemplateRef<any>;
  @ViewChild('apjTpl') apjTpl!: TemplateRef<any>;
  @ViewChild('actionTpl') actionTpl!: TemplateRef<any>;

  columns: DataTableColumn[] = [];
  allRows: any[] = [];
  page: number = 1;
  itemsPerPage: number = 10;

  get rows(): any[] {
    const start = (this.page - 1) * this.itemsPerPage;
    return this.allRows.slice(start, start + this.itemsPerPage);
  }

  get totalItems(): number {
    return this.allRows.length;
  }

  private readonly americasRegions = ['USA', 'CANADA', 'LATAM'];

  constructor(
    private managerService: ManagerService,
    private popupMessageService: PopupMessageService
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    setTimeout(() => {
      this.buildColumns();
      this.getBudgetData();
    });
  }

  buildColumns() {
    this.columns = [
      { field: 'quarter', header: 'Quarter', cellTemplate: this.quarterTpl },
      { field: 'americasAmount', header: 'Americas', cellTemplate: this.americasTpl },
      { field: 'apjAmount', header: 'APJ', cellTemplate: this.apjTpl },
      { field: 'action', header: 'Action', cellTemplate: this.actionTpl },
    ];
  }

  getBudgetData() {
    this.managerService.getQuarterLevelBudgetcapData('').subscribe((data: any) => {
      const list: any[] = Array.isArray(data)
        ? data
        : Array.isArray(data.content) ? data.content : Array.isArray(data.body) ? data.body : [];

      const grouped: { [key: string]: any[] } = {};
      list.forEach((entry: any) => {
        const key = `${entry.quarter}_${entry.fiscalYear}`;
        if (!grouped[key]) { grouped[key] = []; }
        grouped[key].push(entry);
      });

      this.allRows = Object.keys(grouped).map((key: string) => {
        const entries = grouped[key];
        const a = entries.find((e: any) => e.regions.some((r: string) => this.americasRegions.includes(r)));
        const b = entries.find((e: any) => !e.regions.some((r: string) => this.americasRegions.includes(r)));
        return {
          quarter: entries[0].quarter,
          fiscalYear: entries[0].fiscalYear,
          americasId: a ? a.id : null,
          americasAmount: a ? a.amount : null,
          americasRegions: a ? a.regions : ['USA', 'CANADA', 'LATAM'],
          americasLocked: a ? a.budgetLocked : true,
          apjId: b ? b.id : null,
          apjAmount: b ? b.amount : null,
          apjRegions: b ? b.regions : ['APJ'],
          apjLocked: b ? b.budgetLocked : true,
          isEditing: false
        };
      });
      this.page = 1;
    });
  }

  onPageChange(p: number) {
    this.page = p;
  }

  startEdit(row: any) {
    row._origAmericas = row.americasAmount;
    row._origApj = row.apjAmount;
    row.isEditing = true;
  }

  resetEdit(row: any) {
    row.americasAmount = row._origAmericas;
    row.apjAmount = row._origApj;
    row.isEditing = false;
  }

  saveBudget(row: any) {
    const calls: any[] = [];
    if (!row.americasLocked && Number(row.americasAmount) !== Number(row._origAmericas)) {
      const americasBody = {
        amount: Number(row.americasAmount),
        quarter: row.quarter,
        fiscalYear: row.fiscalYear,
        regions: row.americasRegions,
        budgetLocked: row.americasLocked
      };
      if (row.americasId) {
        calls.push(this.managerService.updateBudgetcapData(row.americasId, americasBody));
      } else {
        calls.push(this.managerService.saveQuarterLevelBudget(americasBody));
      }
    }
    if (!row.apjLocked && Number(row.apjAmount) !== Number(row._origApj)) {
      const apjBody = {
        amount: Number(row.apjAmount),
        quarter: row.quarter,
        fiscalYear: row.fiscalYear,
        regions: row.apjRegions,
        budgetLocked: row.apjLocked
      };
      if (row.apjId) {
        calls.push(this.managerService.updateBudgetcapData(row.apjId, apjBody));
      } else {
        calls.push(this.managerService.saveQuarterLevelBudget(apjBody));
      }
    }
    if (calls.length === 0) { return; }
    forkJoin(calls).subscribe(
      () => {
        row.isEditing = false;
        this.popupMessageService.showSuccess('Budget updated successfully.', 'success');
        this.getBudgetData();
      },
      (err: any) => {
        row.isEditing = false;
        this.popupMessageService.showError('Failed to update budget: ' + (err && err.message ? err.message : 'Unknown error'), 'error');
      }
    );
  }
}
